import arabicUiCopy from "../../statics/arabicUiCopy";
import localizationStrings from "../../statics/localization";

export const getProfileCopy = () =>
  localizationStrings.getLanguage() === "arb" ? { ...arabicUiCopy.profile, parentPin: "رمز PIN للملف الشخصي الرئيسي", parentPinNote: "أدخل رمز PIN للملف الشخصي الرئيسي للمتابعة." } : localizationStrings.getLanguage() === "tr"
    ? {
        eyebrow: "ATLAS · SANA ÖZEL",
        choose: "Kim izliyor?",
        intro: "Her profil, kendine ait bir dünya.",
        manage: "Profillerini düzenle",
        manageNote: "Kişisel izleme alanını düzenlemek için bir profil seç.",
        edit: "Profilini kişiselleştir",
        editNote: "İsmin, avatarın ve sana özel izleme deneyimin.",
        create: "Yeni bir dünya aç",
        createNote:
          "Yeni bir profil oluştur, her hikâyeye kendi yerinden başla.",
        avatars: "Tarzını seç",
        avatarsNote: "Seni yansıtan bir avatarla profilini tamamla.",
        avatar: "Avatarı değiştir",
        avatarEmpty: "Avatarlar yüklenemedi.",
        retry: "Tekrar dene",
        kidsNote: "Çocuklara özel bir izleme alanı.",
        active: "Aktif profil",
        kids: "Çocuk profili",
        profile: "Kişisel profil",
        pinTitle: "Hikâyene devam et",
        pinEditTitle: "Profilinin kilidini aç",
        pinNote: "Sana özel dünyana girmek için PIN’ini gir.",
        pinEditNote: "Bu profili düzenlemek için PIN’ini gir.",
        pinHint: "4 haneli profil PIN’i",
        currentPin: "Bu profilin mevcut PIN’i",
        parentPin: "Ana profilin PIN’i",
        parentPinNote: "Devam etmek için ana profilin PIN’ini gir.",
        partialCreate: "Profil oluşturuldu ancak ayarları tamamlanamadı. Bu profili düzenleyerek devam edin.",
        pinContinue: "Devam et",
        pinLoading: "Sana özel dünyan hazırlanıyor…",
        pinError: "Şu anda devam edemedik. Tekrar deneyebilirsin."
      }
    : {
        eyebrow: "ATLAS · MAKE IT YOURS",
        choose: "Who’s watching?",
        intro: "A world of stories. A space of your own.",
        manage: "Make room for everyone",
        manageNote: "Select a profile to personalise its viewing experience.",
        edit: "Make it your own",
        editNote: "Your name, your avatar, your way to watch.",
        create: "A new world awaits",
        createNote: "Create a profile and make every story your own.",
        avatars: "Find your character",
        avatarsNote: "Choose an avatar that feels like you.",
        avatar: "Change avatar",
        avatarEmpty: "We couldn’t load the avatars.",
        retry: "Try again",
        kidsNote: "A dedicated viewing space for children.",
        active: "Current profile",
        kids: "Kids profile",
        profile: "Personal profile",
        pinTitle: "Your story continues",
        pinEditTitle: "Unlock your profile",
        pinNote: "Enter your PIN to step into your own world.",
        pinEditNote: "Enter your PIN to personalise this profile.",
        pinHint: "4-digit profile PIN",
        currentPin: "Current PIN for this profile",
        parentPin: "Main profile PIN",
        parentPinNote: "Enter the main profile PIN to continue.",
        partialCreate: "The profile was created, but its settings could not be completed. Edit this profile to continue.",
        pinContinue: "Continue",
        pinLoading: "Getting your world ready…",
        pinError: "We couldn’t continue right now. Please try again."
      };
